module.exports = "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\"><path d=\"M25 13.1v23.8M36.9 25H13.1\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-styles/icons/stroke/add.svg
// module id = 237
// module chunks = 0